<template>
	<div>
		<TriangleImage
		/>

		<div class="container">
			<div class="content">

				<router-link
					:to="{ name: 'flow-subscribed' }"
					class="flex-center"
				>
					<CTA
						:content="`Acquista ora`"
						isArrow
					/>
				</router-link>
				<br>
						
				<section class="center">
					<p>Galbani a casa tua arriva con tante novità per la tua spesa on line.
Una volta alla settimana infatti hai la possibilità di ordinare, oltre ai tuoi prodotti Galbani preferiti, anche degli appetitosi kit di ricette che contengono tutti gli ingredienti necessari per creare i tuoi piatti.
Oltre a darti gusto e varietà, con questo servizio Galbani mette al centro la sostenibilità: meno sprechi di cibo, packaging riciclabile e compostabile, ingredienti stagionali e di provenienza controllata. In aggiunta, un albero piantato per ogni ordine spedito.</p>
				</section>

				<h2 class='center'>Ecco come funziona:</h2>

				<section>
					<div class="image">
						<img src="https://api.quomi.it/oldimg/Prima_immagine-%281%29.jpg">
					</div>

					<div class="description">
						<h2>1. Scegli la tua ricetta oppure i tuoi prodotti Galbani preferiti.</h2>
						<p>Su Galbani a casa tua puoi ordinare i comodi <b>Kit Ricetta</b> dal menù settimanale, le <b>cassette di frutta e verdura di stagione</b> e tanti altri kit e prodotti sempre di qualità certificata: <b>vini, olio, latticini e tanto altro.</b></p>
					</div>
				</section>

				<hr>

				<section v-if="$mq.isDesktop()">
          
          <div class="description">
            <h2>2. La spesa la facciamo noi.</h2>
            <p>Una volta ricevuto il tuo ordine componiamo il tuo kit ricetta con i prodotti Galbani necessari e gli altri ingredienti.</p>
          </div>

          <div class="image">

            <img src="https://api.quomi.it/oldimg/Seconda_immagine-%281%29.jpg">

          </div>
				</section>
        <section v-else>

          <div class="image">

            <img src="https://api.quomi.it/oldimg/Seconda_immagine-%281%29.jpg">

          </div>
          
          <div class="description">
            <h2>2. La spesa la facciamo noi.</h2>
            <p>Una volta ricevuto il tuo ordine componiamo il tuo kit ricetta con i prodotti Galbani necessari e gli altri ingredienti.</p>
          </div>
        </section>


				<hr>

				<section>
					<div class="image"><img src="https://api.quomi.it/oldimg/2X3_ALL.JPG">
						<br>
						<router-link :to="{ name: 'how-we-recycle' }" class="link">Scopri come riciclare la tua box</router-link>
					</div>

					<div class="description">
						<h2>3. Direttamente a casa tua il tuo kit ricetta.</h2>
						<p>Ti consegiamo la spesa nel giorno e orario che avrai indicato.
La nostra box è pensata per garantire la qualità e la freschezza di tutti gli ingredienti. Inoltre, con le schede della ricetta contenute, potrai seguire le istruzioni di preparazione passo passo.</p>
					</div>
				</section>




				<div>
					<div>
						<router-link
							:to="{ name: 'flow-subscribed' }"
							class="flex-center"
						>
							<CTA
								:content="`Acquista ora`"
								isArrow
							/>
						</router-link>
						<br>
						<h3>Scegli la tua ricetta oppure i tuoi prodotti Galbani preferiti</h3>
						
						
					</div>
					<br>

					<hr>

					<section>
						<div class="contacts mt-5">
							<h2 class="text-center">Siamo a tua disposizione</h2>
							<p>Vuoi sapere di più sul servizio? Non esitare a contattarci, il nostro customer care è attivo dal lunedì al venerdì dalle 10.00 alle 16.00. Ecco i nostri contatti:</p>
							<ul class="contacts-list ma-auto">
								<li><img src="../../assets/img/how/envelope.png" class="icon-contact">E-mail: <a href="mailto:acasatua@quomi.it">acasatua@quomi.it</a></li>
								<li><img src="../../assets/img/how/phone-call.png" class="icon-contact">Numero di telefono: 02 80 88 92 66</li>
							</ul>

						</div>
					</section>

					<BigUsp>
						<template slot="icon"><i class="fa fa-question-circle fa-4x" aria-hidden="true" /></template>
						<template slot="title">Domande frequenti</template>
						<template slot="message">
							<p>Se hai ancora qualche dubbio, visita la nostra sezione <router-link :to="{name: 'faq'}" class="link-detail" title="Domande frequenti">domande frequenti</router-link><br>oppure scrivici in chat, la trovi qui a destra</p>
						</template>
					</BigUsp>

				</div>




			</div>
		</div>

	</div>
</template>

<script>

import TriangleImage from '../../components/TriangleImage'

import StartWithUs from '../../components/Parts/StartWithUs'
import ContinueToShop from '../../components/Parts/ContinueToShop'
import BigUsp from '../../components/Parts/BigUsp'
import { container } from '../../services/container'

export default {
	components: {
		TriangleImage,
    ContinueToShop,
		StartWithUs,
		BigUsp
	},
  mounted () {
    let param = 'galbani';
    container.get('services.cookies').set('user_source_track', param);
    container.get('source').updateValue(param);
  }
}

</script>

<style scoped>
	.content {
		max-width: 1024px;
	}

	.content > section {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		
		margin: 0px auto 30px auto;
	}

	h2 {
		margin-bottom: 30px;
	}

	h3 {
		text-align: center;
	}

	.content > section > div {
		padding: 20px 0px;
		max-width: 470px;
		margin: 0 auto;
	}

	.content > section .image {
		text-align: center;
	}

	.link {
		color: #399ec9;
	}

	.link:hover {
		color: #328fb7;
		text-decoration: underline;
	}

	.icon-contact {
		width: 35px;
		margin-right: 10px;
	}

	.contacts,
	.abo {
		display: flex;
		flex-direction: column;
		align-self: start;
	}

	.calendar {
		margin: 10px 0;
	}

	.contacts-list {
		list-style: none;
	}

	.contacts-list {
		text-align: left;
		width: 250px;
	}

	.contacts-list li {
		padding: 10px 0;
	}

	.triangle-image {
		background-image: url("./how-works-bg.jpg");
		background-position: center center;
    padding: 310px 0;
	}

	.fa-question-circle {
		color: var(--quomi-primary);
	}
  @media (max-width: 1024px) {
    .triangle-image {
      min-height: 220px;
      padding: 25px 0;
    }
  }

</style>
